import { fetchWechatJSSDK } from '@/apis/account';
import { config } from '@/utils/config';
import { isWechat, urlReg } from '@/utils/regex';
import { IWechatSharedConfig, wechatInit, wechatSharedInit } from '@/utils/wechat';

/**
 * @description 微信分享配置Hooks
 * @author Wynne
 * @date 2021-03-16
 * @param {IWechatSharedConfig} [config]
 */
export const useWechat = (wechatSharedConfig:IWechatSharedConfig, isDebug = false) => {
  if (!urlReg.test(wechatSharedConfig.link)) {
    throw new Error('link 格式不正确！！');
  }
  if (!urlReg.test(wechatSharedConfig.imgUrl)) {
    throw new Error('imgUrl 格式不正确！！');
  }
  if (!isWechat) return;
  fetchWechatJSSDK({
    url: location.href.split('#')[0],
    js_api_list: ['updateAppMessageShareData', 'updateTimelineShareData'],
    appid: config.wechat.appId,
  }).then((res) => {
    const { data } = res;
    wechatInit({
      debug: isDebug,
      appId: data.appId,
      nonceStr: data.nonceStr,
      signature: data.signature,
      timestamp: data.timestamp,
      jsApiList: data.jsApiList,
    }).then((res) => {
      wechatSharedInit(wechatSharedConfig);
    }).catch((err) => {
      console.log(err);
    });
  }).catch((err) => console.log(err));
};

